// Standard authenticator-app pairing details (Key URI format used by
// Google Authenticator, 1Password, Authy, Microsoft Authenticator, …).
// Cognito issues SHA-1, 6-digit, 30-second TOTP secrets.
export const TOTP = Object.freeze({ algorithm: 'SHA1', digits: 6, period: 30 });

export function otpauthUri({ issuer, account, secret }) {
  const label = `${encodeURIComponent(issuer)}:${encodeURIComponent(account)}`;
  const params = new URLSearchParams({
    secret,
    issuer,
    algorithm: TOTP.algorithm,
    digits: String(TOTP.digits),
    period: String(TOTP.period),
  });
  return `otpauth://totp/${label}?${params}`;
}

// "JBSWY3DPEHPK3PXP" -> "JBSW Y3DP EHPK 3PXP" — easier to read and type.
export function formatSetupKey(secret) {
  return String(secret).replace(/\s+/g, '').match(/.{1,4}/g).join(' ');
}
